/*
 * This component goal is to display the position of the print mode page breaks.
 */
import React from 'react';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import { PageSeparator } from 'business/definitions';
import { Box } from '@mui/material';

type Props = {
    pageSeparators: PageSeparator[];
};

const StyPageNumber = styled(Typography, {
    name: 'StyPageNumber',
    shouldForwardProp: (prop) => prop !== 'pageSeparator',
})<{ pageSeparator: PageSeparator }>(({ pageSeparator }) => ({
    position: 'absolute',
    whiteSpace: 'pre',
    fontWeight: pageSeparator.isCuttingWidget ? 'bold' : 400,
}));

const StyPageSeparator = styled('div', {
    name: 'StyPageSeparator',
    shouldForwardProp: (prop) => prop !== 'pageSeparator',
})<{ pageSeparator: PageSeparator }>(({ pageSeparator }) => ({
    position: 'absolute',
    border: `dashed grey ${pageSeparator.isCuttingWidget ? 2 : 1}px`,
    width: '100%',
    top: pageSeparator.yPos,
}));

const StySeparatorsContainer = styled('div', {
    name: 'StySeparatorsContainer',
})({
    position: 'relative',
    zIndex: 1300,
    width: '100%',
});

/*
 * Display a sequence of horizontal lines, corresponding to page breaks, like this:
 *
 * Page N
 * -----------------------
 * Page N + 1
 */
const PrintPaginationSeparators = ({
    pageSeparators,
}: Props): React.ReactElement => (
    <StySeparatorsContainer>
        {pageSeparators.map((pageSeparator, index) => (
            <Box key={pageSeparator.yPos}>
                <StyPageNumber
                    sx={{ top: pageSeparator.yPos - 30 }}
                    pageSeparator={pageSeparator}
                >
                    {`Page ${index + 1}`}
                </StyPageNumber>
                <StyPageSeparator pageSeparator={pageSeparator} />
                <StyPageNumber
                    sx={{ top: pageSeparator.yPos + 20 }}
                    pageSeparator={pageSeparator}
                >
                    {`Page ${index + 2}`}
                </StyPageNumber>
            </Box>
        ))}
    </StySeparatorsContainer>
);

export default PrintPaginationSeparators;
